var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"observe",staticClass:"interactive-text text-center"},[_vm._v(_vm._s(_vm.$t("loading.more")))])
}
var staticRenderFns = []

export { render, staticRenderFns }